enum BackgroundColorClass {
  BackgroundOverlay = "backgroundColorBackgroundOverlay",
  BrightPurple = "backgroundColorBrightPurple",
  Dimmer = "backgroundColorDimmer",
  Error = "backgroundColorError",
  Green = "backgroundColorGreen",
  Ghost = "backgroundColorGhost",
  LightBlue = "backgroundColorLightBlue",
  LightPink = "backgroundColorLightPink",
  LightPurple = "backgroundColorLightPurple",
  LightPurpleHover = "backgroundColorLightPurpleHover",
  Navy = "backgroundColorNavy",
  NavyHover = "backgroundColorNavyHover",
  Pink = "backgroundColorPink",
  Primary = "backgroundColorPrimary",
  Purple = "backgroundColorPurple",
  Red = "backgroundColorRed",
  RedHover = "backgroundColorRedHover",
  Secondary = "backgroundColorSecondary",
  Shader = "backgroundColorShader",
  Tertiary = "backgroundColorTertiary",
  White = "backgroundColorWhite",
  Yellow = "backgroundColorYellow",
  PhantomPurple = "backgroundColorPhantomPurple",
}

export default BackgroundColorClass;
